import { ReactElement } from 'react';

import { TLabelProps } from './Label.interface';
import RequiredAsterisk from './RequiredAsterisk';
import cn from 'utils/cn';

type Props = {
  label: string | ReactElement<any>;
  required?: boolean;
} & TLabelProps;

const Label = ({ label, labelProps, required }: Props): ReactElement<any> => {
  return (
    <label
      {...labelProps}
      className={cn(
        `mume-form-label tw:block tw:text-sm/4 tw:normal-case tw:mb-2`,
        labelProps?.className
      )}
    >
      {label}
      <RequiredAsterisk required={required} />
    </label>
  );
};

export default Label;
